import { apiServices } from "../../../../core/utilities/ApiServices";
import InfoNotificationAdmin from "../../domain/entities/InfoNotificationAdmin";
import PaginationNotification from "../../domain/entities/PaginationNotification";

export interface NotificationDataSource {
	getNotification(params: PaginationNotification): Promise<InfoNotificationAdmin[]>;
	deleteNotification(notification_id: string): Promise<void>;
}

export class NotificationDataSourceImpl implements NotificationDataSource {
	async getNotification(params: PaginationNotification): Promise<InfoNotificationAdmin[]> {
		const response = await apiServices.get(`/notification`, { params });
		if (response.status === 200) {
			return response.data;
		} else {
			throw new Error("Error fetching places");
		}
	}
	async deleteNotification(notification_id: string): Promise<void> {
		const response = await apiServices.delete(`/notification`, { params: { notification_id } });
		if (response.status === 200) {
			return;
		} else {
			throw new Error("Error deleting notification");
		}
	}
}
